if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        const variantId = this.dataset.variantId;

        if (variantId) {
          this.fetchAvailability(variantId);
        }
      }

      fetchAvailability(variantId) {
        if (!variantId) {
          this.clearAvailability();
          return;
        }

        let rootUrl = this.dataset.rootUrl || '/';

        if (!rootUrl.endsWith('/')) {
          rootUrl += '/';
        }

        const sectionUrl =
          `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(sectionUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Pickup availability request failed with status ${response.status}`
              );
            }

            return response.text();
          })
          .then((html) => {
            const parsedDocument = new DOMParser().parseFromString(
              html,
              'text/html'
            );

            const section = parsedDocument.querySelector('.shopify-section');

            this.updateAvailability(section);
          })
          .catch((error) => {
            console.error('Error fetching pickup availability:', error);
            this.renderError();
          });
      }

      updateAvailability(section) {
        if (!section) {
          this.clearAvailability();
          return;
        }

        const newAvailability = section.querySelector(
          '.pickup-availability-information'
        );

        if (!newAvailability) {
          this.clearAvailability();
          return;
        }

        this.innerHTML = newAvailability.innerHTML;

       const renderedAvailability = this.querySelector(
  '.pickup-availability-information[data-available]'
);

const pickupIsAvailable =
  renderedAvailability?.dataset.available === 'true';

        if (pickupIsAvailable) {
          this.setAttribute('available', '');

          const stockMessage = this.querySelector(
            '.pickup-availability-information__stock'
          );

          if (stockMessage) {
            stockMessage.innerHTML = this.getPickupMessage();
          }
        } else {
          this.removeAttribute('available');
        }

        this.updatePickupPanel(section);
      }

      updatePickupPanel(section) {
        const newPanel = section.querySelector('#Pickup-Availability');
        const currentPanel = document.querySelector('#Pickup-Availability');

        if (currentPanel && newPanel) {
          currentPanel.replaceWith(newPanel);
          return;
        }

        if (currentPanel && !newPanel) {
          currentPanel.remove();
          return;
        }

        if (!currentPanel && newPanel) {
          document.body.appendChild(newPanel);
        }
      }

      clearAvailability() {
        this.innerHTML = '';
        this.removeAttribute('available');

        const currentPanel = document.querySelector('#Pickup-Availability');

        if (currentPanel) {
          currentPanel.remove();
        }
      }

      getPickupMessage() {
        const now = new Date();
        const day = now.getDay();
        const hour = now.getHours();

        if (
          (day === 5 && hour >= 15) ||
          (day === 6 && hour >= 15) ||
          day === 0 ||
          (day === 1 && hour < 9)
        ) {
          return 'Available for pickup on <strong>Monday</strong> from <strong>12 PM</strong>';
        }

        if (day >= 1 && day <= 4 && hour >= 15) {
          return 'Available for pickup <strong>tomorrow</strong> from <strong>12 PM</strong>';
        }

        if (day >= 1 && day <= 6 && hour < 10) {
          return 'Available for pickup <strong>today</strong> after <strong>12 PM</strong>';
        }

        return 'Available for pickup in <strong>2 hours</strong>';
      }

      renderError() {
        this.innerHTML =
          '<p class="pickup-availability-information__error">Pickup availability information could not be loaded.</p>';

        this.removeAttribute('available');
      }
    }
  );
}